<dt-modal-content [flexContent]="true" (closeClick)="dialogRef.close()">
  <ng-template #title i18n>Fehlende Daten</ng-template>

  <ng-template #content>
    <p>
      {{ data.message }}
      <ng-container i18n>Beachte dabei auch folgende Punkte:</ng-container>
    </p>
    @for (err of data.errors; track err) {
      <mat-error class="dt-error">
        <dt-error-msg [error]="err"></dt-error-msg>
      </mat-error>
    }
  </ng-template>

  <ng-template #footer>
    <button mat-raised-button color="accent-less" (click)="dialogRef.close()" i18n>Schließen</button>
  </ng-template>
</dt-modal-content>
